import type { NovelStyleTemplate } from "~/src/novel/style";

const defaultSettings = {
  styleClass: "",
  fontFamily: "inherit",
  bold: false,
  justify: false,
  fontRatio: 1,
  letterSpacing: 0,
  wordSpacing: 0,
  lineHeight: 1.5,
};

const ORIGINAL: NovelStyleTemplate = {
  ...defaultSettings,
  name: "Original",
  styleClass: "original",
  readerStyleClass: "reader-original",
};

const QUIET: NovelStyleTemplate = {
  ...defaultSettings,
  name: "Quiet",
  styleClass: "quiet",
  readerStyleClass: "dark reader-quiet",
};

const PAPER: NovelStyleTemplate = {
  ...defaultSettings,
  name: "Paper",
  styleClass: "paper",
};

const BOLD: NovelStyleTemplate = {
  ...defaultSettings,
  name: "Bold",
  styleClass: "theme-bold",
  readerStyleClass: "reader-bold",
  bold: true,
};

const CALM: NovelStyleTemplate = {
  ...defaultSettings,
  name: "Calm",
  styleClass: "calm",
  readerStyleClass: "reader-calm",
};

const FOCUS: NovelStyleTemplate = {
  ...defaultSettings,
  name: "Focus",
  styleClass: "focus",
  readerStyleClass: "reader-focus",
};

const clone = (obj: object) => JSON.parse(JSON.stringify(obj));

export const getNovelThemes = () => [
  clone(ORIGINAL),
  clone(PAPER),
  clone(QUIET),
  clone(BOLD),
  clone(FOCUS),
  clone(CALM),
];
